module.exports = __webpack_public_path__ + "img/copy3.2d960937.svg";